export default {
  props: ['items', 'cols'],
  data() {
    return {
      backToAllAlbums: false,
      showBackButton: true,
    };
  },
  computed: {
    prevUrl() {
      return this.backToAllAlbums ? null : 'gallery';
    },
    col() {
      return 12 / this.cols || 4;
    },
  },
  methods: {
    getThumbnail(item) {
      return item.primary_photo
          ? item.primary_photo.medium_photo
          : item.first_photo
              ? item.first_photo.medium_photo
              : null;
    }
  },
  created() {
    switch (this.$route.name) {
      case 'home':
      case 'all-albums':
      case 'albums-archive':
        this.showBackButton = false;
    }

    if (this.prevRoute && this.prevRoute.name) {
      switch (this.prevRoute.name) {
        case 'home':
        case 'all-albums':
        case 'albums-archive':
          this.backToAllAlbums = true;
      }
    }
  }
};
